import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { remote } from '../../globals'


const initialState = {
  interpretation: "",
  isLoading: false,
}

export const interpretDream = createAsyncThunk(
  'interpreter/fetchInterpretation',
  async (dreamText) => {
    const response = await axios.post(
      `${remote}/psychic/`,
      {
        dream: dreamText
      }
    );
    return response.data
  }
)

export const interpreterSlice = createSlice({
  name: 'interpreter',
  initialState,
  reducers: {
    resetInterpretation: (state) => {
      state.interpretation = "";
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(interpretDream.pending, (state) => {
        state.interpretation = "";
        state.isLoading = true;
      })
      .addCase(interpretDream.fulfilled, (state, action) => {
        state.interpretation = action.payload;
        // some nonsense to slow peple down if they are entering invalid dreams.
        if(state.interpretation === 500) {
          state.isLoading = true;
        } else {
          state.isLoading = false;
        }
      })
  }
})

export const { resetInterpretation } = interpreterSlice.actions;

export const getIsLoading = (state) => state.interpreter.isLoading;
export const getInterpretation = (state) => state.interpreter.interpretation;

export default interpreterSlice.reducer;
